import i18next from "i18next";

import { components } from "@/api-schema";
import { DmsSystem } from "@/api-schema-enums";
import { RowWithIdentifier } from "@/components/data-table/_helpers/row-identifier";

type CustomerTableType = components["schemas"]["Customer"] & RowWithIdentifier;
type CustomerIdentifier = NonNullable<CustomerTableType["customerIdentifiers"]>[number];

interface IdentifierInfo {
  identifiers: CustomerIdentifier[] | undefined;
}

export interface IdentifierRow {
  key: string;
  label: string;
  value: string;
}

export const getIdentifierLabel = (type: DmsSystem): string => i18next.t(`masterdata:DmsSystem${type}`);

export const getIdentifierRows = ({ identifiers }: IdentifierInfo): IdentifierRow[] => {
  const rows: IdentifierRow[] = [];

  const sapIdentifier = identifiers?.find((identifier) => identifier.type === DmsSystem.Sap);
  if (sapIdentifier) {
    rows.push({ key: "sap", label: getIdentifierLabel(DmsSystem.Sap), value: sapIdentifier.identifier });
  }

  for (const identifier of identifiers ?? []) {
    if (identifier.type === DmsSystem.Sap) {
      continue;
    }

    rows.push({
      key: identifier.uuid,
      label: getIdentifierLabel(identifier.type),
      value: identifier.identifier,
    });
  }

  return rows;
};
